import Glide from "@glidejs/glide";

let slider = document.getElementById('js-glide-realisations')
if (slider) {
  function ArrowDisabler (Glide, Components) {
    return {
      mount() {
        // Only in effect when rewinding is disabled
        if (Glide.settings.rewind) {
          return
        }

        Glide.on(['mount.after', 'run'], () => {
          for (let controlItem of Components.Controls.items) {
            // Set left arrow state
            let left = controlItem.querySelector('#control-left')
            if (left) {
              if (Glide.index === 0) {
                left.classList.add('hidden')
              } else {
                left.classList.remove('hidden')
              }
            }
            // Set right arrow state
            let right =  controlItem.querySelector('#control-right')
            if (right) {
              // Glide.index is based on the active slide
              // For bound: true, there will be no empty space & the last slide will never become active
              // Hence add perView to correctly calculate the last slide
              const lastSlideIndex = Glide.settings.bound
                ? Glide.index + (Glide.settings.perView - 1)
                : Glide.index;
  
              if (lastSlideIndex === Components.Sizes.length - 1) {
                right.classList.add('hidden')
              } else {
                right.classList.remove('hidden')
              }
            }
          }
        })
      }
    }
  }

  const CustomLength = function(Glide, Components, Events) {
    return {
      mount () {
        Events.emit('slider.length', Components.Sizes.length)
      }
    }
  }

  const config = {
    perView: 5,
    bound:true,
    gap:10,
    rewind: false,
    type: 'slider',
    breakpoints: {
      800: {
        perView: 2
      },
      480: {
        perView: 1
      }
    }
  };
  let glide = new Glide('.glide-realisations', config)

  glide.on('slider.length', (length) => {
    if(length <= 5){
      glide.disable()
    }
  })

  glide.mount({
    CustomLength,
    ArrowDisabler
  })


}


